import React, { Component } from 'react'
import { Input, Select, Spin, Table, Tooltip, message, Button, Divider, notification } from 'antd';
import { defaultDateFormat, showErrorInNotification, NetworkDelaySearch, copyStringToClipboard } from '../../lib/util';
import moment from 'moment';
import FilterFixedInput from '../../components/filter_fixed_input';
import NetworkSelect from '../../lib/ui/network_select';
import { BasicHeader } from '../../components/basic_header';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { COLORS } from '../theme';
import { Link } from 'react-router-dom';
import { GetAppOutlined } from '@material-ui/icons';
import DebugFilePreview from '../../components/debug_file_preview';


var re = /(?:\.([^.]+))?$/;

class FileDetailRaw extends Component {
    constructor(props) {
        super(props)

        this.datatype = props.match.params.datatype_id;
        this.file_id = props.match.params.file_id;

        this.state = {
            loading: true,
            file_obj: {},
            url: null,
            extension: null,
            highlighter: [],
            highlighter_downloaded: false
        }

        this.file_detail = RESTExecutor.detail().config({
            label: 'file_detail',
            params: {
                file_id: this.file_id
            }
        }).callbacks((success) => {
            this.setState({
                loading: false, file_obj: success.result,
                extension: success.result.file_type
            })

            this.getUrl(this.datatype, {
                file_id: this.file_id,
                attachment: true
            }, true);
            this.get_highlighter.forId(this.datatype).config({
                params: {
                    file_id: this.file_id
                }
            }).execute()
            // overrideHeaderTitle(`${success.result.name} | Files`);
            // this.list_raw_data.forId(this.datatype).config({
            //     params: {
            //         ...this.state.filter_query
            //     }
            // }).execute();
        }, (error) => {
            showErrorInNotification(error);
            this.setState({ loading: false })
        }).forId(this.datatype).connect(props.domains.activity);

        this.get_highlighter = RESTExecutor.list().config({
            label: 'file_highlighter',
            params: {}
        }).callbacks((success) => {
            this.setState({
                highlighter: success.result,
                highlighter_downloaded: true
            })
        }, (error) => {
            message.error("Highlighter Download Failed")
            showErrorInNotification(error);
            this.setState({
                highlighter_downloaded: true
            })
        }).connect(props.domains.activity);


        this.reprocess_file = RESTExecutor.post().config({
            label: 'file_reprocess',
            params: {}
        }).callbacks((success) => {
            try {
                this.loading_message();
            } catch (e) {

            }
            message.success(success.result.message || "Reprocessing File");
        }, (error) => {
            try {
                this.loading_message();
            } catch (e) {

            }
            showErrorInNotification(error);
        }).connect(props.domains.activity);

        this.get_file_url = RESTExecutor.detail().config({
            label: 'file_download',
            params: {}
        }).callbacks((success) => {
            this.setState({
                url: `${success.result.url}`
            })
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.activity);

    }

    getUrl = (datatype, params, preview = false) => {
        if (preview) {
            this.get_file_url.forId(datatype).config({
                params: params,
            }).callbacks((success) => {
                this.setState({
                    //FOR TEST ONLY

                    url:`${success.result.url}`.includes("localhost:3000")?`${success.result.url}`.replace("localhost:3000","165.22.243.195"):`${success.result.url}`
                })
            }, (error) => {
                showErrorInNotification(error);
            }).execute()
        } else {
            this.get_file_url.forId(datatype).config({
                params: params
            }).callbacks((success) => {
                window.open(success.result.url, '_blank');
                try {
                    this.loading_message();
                } catch (e) {

                }
            }, (error) => {
                showErrorInNotification(error);
                try {
                    this.loading_message();
                } catch (e) {

                }
            }).execute()
        }
    }

    render() {

        const { filter_query, loading, file_obj, highlighter_downloaded } = this.state;
        if (loading) {
            return <center><Spin /></center>
        }
        let file_detail_resp = this.file_detail.response();
        let get_file_url_resp = this.get_file_url.response();
        let has_run = file_obj.processed == false || (file_obj.processed == true && file_obj.error == true);

        return (
            <ErrorWrapper
                error={file_detail_resp}
                onReload={() => {
                    this.setState({
                        loading: true
                    }, () => {
                        this.file_detail.forId(this.datatype).execute()
                    })
                }}
            >
                <div>
                    <BasicHeader
                        title={file_obj.data_type}
                        titleType="Datatype"
                        subtitle={"File Detail"}
                    />

                    <div className='filter-card'>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            paddingTop: 4, paddingBottom: 4
                        }}>
                            <span style={{
                                maxWidth: '70%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontSize: 20,
                                color: '#000'
                            }}>
                                File : {file_obj.file_name}
                            </span>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                // justifyContent: 'center'
                            }}>

                                <Button
                                    disabled={!has_run}
                                    title="Rerun"
                                    onClick={() => {
                                        if (!has_run) {
                                            notification.warn({
                                                message: "You cannot re-run this file now."
                                            })
                                        } else {
                                            this.loading_message = message.loading(`Reprocessing ${file_obj.file_name}`, 0);
                                            this.reprocess_file.config({
                                                params: {
                                                    response_id: file_obj.fetcher_response_id,
                                                    file_id: this.file_id
                                                }
                                            }).execute();
                                        }
                                        // typeof props.onRerun==='function'&&props.onRerun(record)
                                    }}
                                    style={{
                                    }} type='link'>Re-run</Button>
                                <Divider type='vertical' />
                                <GetAppOutlined titleAccess="Download File"
                                    onClick={() => {
                                        this.loading_message = message.loading(`Downloading ${file_obj.file_name}`, 0);
                                        this.getUrl(this.datatype, {
                                            file_id: this.file_id,
                                            attachment: true
                                        }, false);
                                    }}
                                    className='basic-icon hand-cursor' />
                            </div>


                        </div></div>

                    <ErrorWrapper
                        error={get_file_url_resp}
                        onReload={() => {
                            this.get_file_url.execute()
                        }}
                    >
                        <div className='filter-card ' style={{
                            // padding:4
                        }}>
                            {this.state.url && <DebugFilePreview
                                url={this.state.url}
                                extension={this.state.extension}
                                highlighter={this.state.highlighter}
                                highlighter_downloaded={highlighter_downloaded}
                            />}

                        </div>
                    </ErrorWrapper>
                </div>
            </ErrorWrapper>
        );
    }

    componentDidMount() {
        this.file_detail.execute();
    }

    componentWillReceiveProps(nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;


        var oldfile_id = this.props.match.params.file_id;
        var newfile_id = nextProps.match.params.file_id;

        if (olddatatype_id !== newdatatype_id ||
            (oldfile_id !== newfile_id)
        ) {
            this.datatype = newdatatype_id;
            this.file_id = newfile_id;
            this.setState({ loading: true });
            this.file_detail.forId(this.datatype).config({
                params: {
                    file_id: this.file_id
                }
            }).execute()


        }
    }


}

export default withDomains(FileDetailRaw, "activity");
